import { Component, OnInit } from "@angular/core";
import { Subscription, timer } from "rxjs";
import { ModalComponent } from "@apps/patient-core/src/app/components/modal/modal.component";
import { OverlayService } from "@apps/patient-core/src/app/services/overlay.service";
import { ConciergeLoginService } from "@apps/concierge-app/src/app/services/concierge-login.service";
import { SHARED } from "@apps/patient-core/src/app/shared";
import { Constants } from "@apps/concierge-app/constants";
import { CacheService } from "@apps/patient-core/src/app/services/cache.service";

@Component({
  selector: "dentr-login-inactivity-modal",
  templateUrl: "login-inactivity-modal.component.html",
  standalone: true,
  imports: [SHARED, ModalComponent],
})
export class LoginInactivityModalComponent implements OnInit {
  private readonly _COUNTER_VAL = 60;
  public countDown: Subscription;
  public counter = this._COUNTER_VAL;

  constructor(private _overlayService: OverlayService, private _conciergeLoginService: ConciergeLoginService, private _cacheService: CacheService) {}

  ngOnInit(): void {
    this._enableTimer();
  }

  public close(): void {
    this._overlayService.close();
    this._disableTimer();
    this._conciergeLoginService.startInactivityMonitor();
  }

  private _disableTimer() {
    if (this.countDown) this.countDown.unsubscribe();
    this._cacheService.delete(Constants.INACTIVITY_TIMER_END_TIME_STORAGE_KEY);
  }

  private _enableTimer() {
    const now = Date.now();
    const storedEnd = this._cacheService.get(Constants.INACTIVITY_TIMER_END_TIME_STORAGE_KEY);
    const endTime = storedEnd ? parseInt(storedEnd) : now + this._COUNTER_VAL * 1000;

    this._cacheService.set(Constants.INACTIVITY_TIMER_END_TIME_STORAGE_KEY, endTime.toString());

    this.counter = Math.max(Math.floor((endTime - now) / 1000), 0); // Sets the counter to the remaining time

    if (this.counter === 0) {
      this._handleLogout();
      return;
    }

    this.countDown = timer(0, 1000).subscribe(() => {
      this.counter = Math.max(Math.floor((endTime - Date.now()) / 1000), 0);

      if (this.counter <= 0) {
        this._handleLogout();
      }
    });
  }

  private _handleLogout() {
    this._disableTimer();
    this._conciergeLoginService.navigateToLogout();
  }
}
